import { EyeOutlined } from '@ant-design/icons';
import { Image } from 'antd';
import useProxySrc from 'hooks/business/useProxySrc';
import { getImageThumb, getTiktokProxyImageSrc } from 'lib/utils/platformImage';
import { useCallback, useMemo, useState } from 'react';
import { toUpperCase } from 'utils/toLowerCase';

interface ProductInfoImageProps {
  imgUrl: string;
  itemName: string;
  size?: number;
  platform?: General.PlatformUpperCaseTunnel | General.Platform;
}

export const ProductInfoImage = (props: ProductInfoImageProps) => {
  const { imgUrl, itemName, size = 48, platform } = props;

  const imageSize = size - 2;

  const { getProxyEnable, errorLog } = useProxySrc();

  const [error, setError] = useState<any>();

  const hasError = Boolean(error);

  const getFastImage = useCallback(
    (image: string) => {
      if (!hasError && getProxyEnable(image)) {
        return getTiktokProxyImageSrc(image);
      }
      return image;
    },
    [hasError, getProxyEnable],
  );

  const thumbnailImage = useMemo(
    () => getImageThumb(imgUrl, toUpperCase(platform)),
    [imgUrl, platform],
  );

  const fastOriginalImage = useMemo(() => getFastImage(imgUrl), [imgUrl, getFastImage]);
  const fastThumbnailImage = useMemo(
    () => getFastImage(thumbnailImage),
    [thumbnailImage, getFastImage],
  );

  return (
    <div
      className="relative rounded-[2px] overflow-hidden border border-solid border-[#F0F2F5] flex-shrink-0"
      style={{ width: size, height: size }}
    >
      <Image
        src={fastThumbnailImage}
        alt={itemName}
        width={imageSize}
        height={imageSize}
        className="object-cover"
        preview={{
          mask: <EyeOutlined />,
          src: fastOriginalImage,
        }}
        onError={(error) => {
          setError(error);
          errorLog(fastThumbnailImage);
        }}
      />
    </div>
  );
};
